import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Envelope } from 'src/app/models/envelope';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';

@Injectable({
    providedIn: 'root',
})
export class OnboardingService {
    private basePath: string = `${environment.apiBaseUrl}api/Account`;
    constructor(private httpClient: HttpClient,
        private router: Router) {
    }

    checkOnboarding(): Observable<any> {
        return this.httpClient
          .get<Envelope<any>>(`${this.basePath}/Onboard`)
          .pipe(
            map((res) => {
              return res.result;
            }),
            catchError((err, caught) => {
              
              return of({});
            })
          );
      }
}